module.exports = __webpack_public_path__ + "static/media/nima_waving_hand.9b7876e2.png";